export const getters = {
	estate: state => state,
	isValidated: state => name => {
		let result = false
		state.validation.forEach((comp) => {
			if (comp.name === name) {
				result = comp.status
			}
		})
		return result
	}
}



// WEBPACK FOOTER //
// ./src/common/store/PatrimonialEstate/getters.js